export default {"src":"/_next/static/media/CL.8dcf94b8.svg","height":18,"width":18};